import React from 'react'

const CambriPaymnetsUtilities = () => {
  return (
    <div>CambriPaymnetsUtilities</div>
  )
}

export default CambriPaymnetsUtilities